import { BasicHeadingControl } from './basicHeadingControl';
import { HpHeadingControlProps } from './headingTypes';

export function DefaultHeadingControl({ friendlyName, isLoading }: HpHeadingControlProps): JSX.Element {
  return (
    <BasicHeadingControl
      heading={friendlyName}
      subheading={isLoading ? 'Our list of questions will appear shortly' : null}
    />
  );
}
